export default __webpack_public_path__ + "static/media/aero-nebulizer.d682c077.jpg";